export type { GoogleVertexImageProviderOptions } from './google-vertex-image-model';
export { createVertex, vertex } from './google-vertex-provider-node';
export type {
  GoogleVertexProvider,
  GoogleVertexProviderSettings,
} from './google-vertex-provider-node';
